import { useCallback } from "react";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	mainTarget: ForNodeType<InputMaybe<string>> | undefined;
	onSetViewModel: (
		values: {
			key: "mainTarget";
			value: ForNodeType<InputMaybe<string>> | undefined;
		}[],
	) => void;
};

export const usePlanMainTarget = ({ mainTarget, onSetViewModel }: Props) => {
	const onSetMainTarget = useCallback(
		(input: string) => {
			const value = !mainTarget ? { isEdited: true, value: input } : { ...mainTarget, value: input };

			onSetViewModel([{ key: "mainTarget", value }]);
		},
		[mainTarget, onSetViewModel],
	);

	return {
		mainTarget,
		onSetMainTarget,
	};
};
